// Module
var code = "<div id=\"drag-ghost\" class=\"drag-ghost\"></div>";
// Exports
export default code;